import { FloatingLoader } from "@/components";
import { NavigationBack } from "@/components/navigation";
import { Typography } from "@/components/text";
import AssignmentRoundedIcon from "@mui/icons-material/AssignmentRounded";
import ChevronRightRounded from "@mui/icons-material/ChevronRightRounded";
import FolderRoundedIcon from "@mui/icons-material/FolderRounded";
import PersonAddAltRoundedIcon from "@mui/icons-material/PersonAddAltRounded";
import PersonRoundedIcon from "@mui/icons-material/PersonRounded";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import AppBar from "@mui/material/AppBar";
import IconButton from "@mui/material/IconButton";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Toolbar from "@mui/material/Toolbar";
import { CASE_CHAT_TABS } from "..";
import EmptyCase from "../../../-components/Empty";

const PendingComponent = () => {
	return (
		<>
			<AppBar
				position="relative"
				color="transparent"
				className="!bg-gradient-account [&_*_]:text-white"
			>
				<Toolbar className="md:!container !gap-4" sx={{ p: 0 }}>
					<NavigationBack />
					<div className="flex flex-col justify-center items-start flex-1">
						<Typography fontSize={14} fontWeight={700}>
							-
							<ChevronRightRounded />
						</Typography>
						<Typography
							fontSize={12}
							fontWeight={400}
							className="flex justify-center items-center gap-2"
						>
							<Typography
								component="span"
								fontSize={12}
								fontWeight={400}
								className="flex items-end gap-1"
							>
								<PersonRoundedIcon fontSize="small" />-
							</Typography>
							<Typography
								component="span"
								fontSize={12}
								fontWeight={400}
								className="flex items-end gap-1"
							>
								<FolderRoundedIcon fontSize="small" />-
							</Typography>
						</Typography>
					</div>
					<div>
						<IconButton color="primary">
							<PersonAddAltRoundedIcon className="text-default " />
						</IconButton>
						<IconButton color="primary">
							<AssignmentRoundedIcon className="text-default " />
						</IconButton>
						<IconButton color="primary">
							<SearchOutlinedIcon className="text-default" />
						</IconButton>
					</div>
				</Toolbar>
				<Toolbar
					className="[&_.MuiTabs-flexContainer]:md:justify-center [&_.MuiTabs-flexContainer]:justify-normal"
					classes={{
						root: "!p-0 !items-end",
					}}
				>
					<Tabs
						variant="scrollable"
						indicatorColor="primary"
						textColor="inherit"
						scrollButtons="auto"
						aria-label="scrollable auto tabs example chat"
						className="w-full [&_span.MuiTabs-indicator]:!bg-white"
					>
						{CASE_CHAT_TABS.map((tab) => (
							<Tab
								key={tab.value}
								label={tab.label}
								sx={{ textTransform: "none" }}
							/>
						))}
					</Tabs>
				</Toolbar>
			</AppBar>
			<main className="relative flex-1 flex-col justify-center items-center">
				<FloatingLoader open />
				<EmptyCase type="chat" title="No discussion yet" />
			</main>
		</>
	);
};

export default PendingComponent;
